import styles from './documents-page.module.sass';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const DocumentsPage = () => {
  const { t } = useTranslation();
  const lang = i18n.language;

  type DocumentItem = {
    title: string;
    pdf: Record<string, string>;
    preview: Record<string, string>;
  };

  const documents: DocumentItem[] = [
    {
      title: 'additionalPages.newsletterInstruction',
      pdf: {
        ru: require('../../assets/pdfs/mailing-instruction.pdf'),
        en: require('../../assets/pdfs/mailing-instruction_en.pdf'),
      },
      preview: {
        ru: require('../../assets/images/previews/mailing-instruction-preview.jpg'),
        en: require('../../assets/images/previews/mailing-instruction-preview_en.jpg'),
      },
    },
    {
      title: 'additionalPages.membersParsingInstruction',
      pdf: {
        ru: require('../../assets/pdfs/parsing-participants.pdf'),
        en: require('../../assets/pdfs/parsing-participants_en.pdf'),
      },
      preview: {
        ru: require('../../assets/images/previews/parsing-participants-preview.jpg'),
        en: require('../../assets/images/previews/parsing-participants-preview_en.jpg'),
      },
    },
    {
      title: 'additionalPages.activitiesParsingInstruction',
      pdf: {
        ru: require('../../assets/pdfs/parsing-activities.pdf'),
        en: require('../../assets/pdfs/parsing-activities_en.pdf'),
      },
      preview: {
        ru: require('../../assets/images/previews/parsing-activities-preview.jpg'),
        en: require('../../assets/images/previews/parsing-activities-preview_en.jpg'),
      },
    },
    {
      title: 'additionalPages.geolocationParsingInstruction',
      pdf: {
        ru: require('../../assets/pdfs/parsing-geo.pdf'),
        en: require('../../assets/pdfs/parsing-geo_en.pdf'),
      },
      preview: {
        ru: require('../../assets/images/previews/parsing-geo-preview.jpg'),
        en: require('../../assets/images/previews/parsing-geo-preview_en.jpg'),
      },
    },
    {
      title: 'additionalPages.privacyPolicy',
      pdf: {
        ru: require('../../assets/pdfs/personal-data-policy.pdf'),
        en: require('../../assets/pdfs/personal-data-policy.pdf'),
      },
      preview: {
        ru: require('../../assets/images/previews/personal-data-policy-preview.jpg'),
        en: require('../../assets/images/previews/personal-data-policy-preview.jpg'),
      },
    },
    {
      title: 'additionalPages.publicOfferAgreement',
      pdf: {
        ru: require('../../assets/pdfs/public-offer.pdf'),
        en: require('../../assets/pdfs/public-offer.pdf'),
      },
      preview: {
        ru: require('../../assets/images/previews/public-offer-preview.jpg'),
        en: require('../../assets/images/previews/public-offer-preview.jpg'),
      },
    },
  ];

  return (
    <main className={styles.wrapper}>
      <div className={styles.cardList}>
        {documents.map((doc, index) => (
          <a
            key={index}
            href={doc.pdf[lang]}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.card}
          >
            <img
              src={doc.preview[lang]}
              alt={t(doc.title)}
              className={styles.cardImage}
            />
            <div className={styles.cardTitle}>{t(doc.title)}</div>
            <div className={styles.decorativeRect}>
              <span className="material-icons">download</span>
            </div>
          </a>
        ))}
      </div>
    </main>
  );
};

export default DocumentsPage;
